import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ProductShot } from './ProductShot';
import { systemChecks, systemNots } from '../data/content';
export function SystemSection() {
  return <section className="bg-navy px-4 py-6 text-white sm:px-6" data-id="element-208" data-mp="3bidi6mobokf1">
      <p className="text-center font-body text-[11px] font-extrabold uppercase tracking-[0.16em] text-mustard" data-id="element-209" data-mp="3bkzn0ejtwltk">
        The complete system you’ve been looking for
      </p>
      <h2 className="mt-1.5 text-center font-heading text-lg font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-210" data-mp="31ma54lrxn1db">
        One complete 6-in-1 senior activity system
      </h2>

      <ProductShot size="md" className="my-3.5" data-id="element-211" data-mp="2stgjm6lw75r0" />

      <div className="text-center" data-id="element-212" data-mp="2ntar6o7stf7v">
        <p className="font-heading text-xl font-extrabold uppercase leading-none text-white sm:text-3xl" data-id="element-213" data-mp="2nu3rp7g5z8hk">
          👥 Senior Activity Ready™
        </p>
        <p className="mt-1 text-[12px] font-extrabold uppercase tracking-wide text-mustard sm:text-sm" data-id="element-214" data-mp="2iw254cjj4r1c">
          The complete ready-to-use activity system
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[12px] font-medium leading-snug text-white/85 sm:text-[13px]" data-id="element-215" data-mp="13xn4xpdpxdup">
          Cognitive, Social, Creative, Recreational &amp; Gentle Movement
          Activities — Organized in One Practical System
        </p>
      </div>

      <ul className="mt-3 flex flex-wrap justify-center gap-1.5" data-id="element-216" data-mp="yzbv3enfb3ch">
        {systemNots.map(item => <li key={item} className="rounded border border-white/25 px-2 py-0.5 text-[11px] font-semibold text-white/70 sm:text-xs" data-id="element-217" data-mp="1mpftn7lr8cwm">
            {item}
          </li>)}
      </ul>

      <div className="mx-auto mt-3 max-w-xl rounded-md bg-white/10 p-3 text-center" data-id="element-218" data-mp="1cr04392dlbp8">
        <p className="text-[12px] font-medium leading-snug text-white/85 sm:text-[13px]" data-id="element-219" data-mp="1hpl2r41zbnbk">
          A practical professional system designed to take you from:
        </p>
        <p className="mt-1 font-heading text-base font-extrabold italic leading-tight text-white/60 sm:text-lg" data-id="element-220" data-mp="6bz66xtsijg0">
          “What are we going to do today?”
        </p>
        <p className="text-[11px] font-bold uppercase text-mustard" data-id="element-221" data-mp="28zxrh6mffqx8">to:</p>
        <p className="font-heading text-base font-extrabold italic leading-tight text-mustard sm:text-lg" data-id="element-222" data-mp="23zjt6gamnvce">
          “I already have an activity ready to run.”
        </p>
      </div>

      <ul className="mx-auto mt-3 grid max-w-2xl gap-1 sm:grid-cols-2" data-id="element-223" data-mp="1u8feziss0eim">
        {systemChecks.map(item => <li key={item} className="flex items-start gap-2" data-id="element-224" data-mp="1pboyiud27gwo">
            <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-mustard" strokeWidth={3} aria-hidden="true" data-id="element-225" data-mp="1l80p064vab8s" />
            <span className="text-[12px] font-semibold leading-snug text-white sm:text-[13px]" data-id="element-226" data-mp="1gbaavocmhpq0">
              {item}
            </span>
          </li>)}
      </ul>
    </section>;
}